"use strict";

exports.__esModule = true;
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SlideDownTransition = _interopRequireDefault(require("./SlideDownTransition"));

var _PropTypes = require("./util/PropTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var StaticContainer = _react.default.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
});

var defaultProps = {
  open: false,
  transition: _SlideDownTransition.default
};
var propTypes = {
  open: _propTypes.default.bool,
  dropUp: _propTypes.default.bool,
  onEntering: _propTypes.default.func,
  onEntered: _propTypes.default.func,
  transition: _PropTypes.elementType
};

function Popup(_ref3) {
  var className = _ref3.className,
      dropUp = _ref3.dropUp,
      open = _ref3.open,
      Transition = _ref3.transition,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, ["className", "dropUp", "open", "transition", "children"]);

  return _react.default.createElement(Transition, _extends({}, props, {
    in: open,
    dropUp: dropUp,
    innerClassName: "rw-popup",
    className: (0, _classnames.default)(className, 'rw-popup-container')
  }), _react.default.createElement(StaticContainer, {
    shouldUpdate: open
  }, children));
}

Popup.propTypes = propTypes;
Popup.defaultProps = defaultProps;
var _default = Popup;
exports.default = _default;
module.exports = exports["default"];